import { formatDistance } from "date-fns";

export function RelativeDate({ date }: { date: string }) {
  const dateObj = new Date(date);
  const now = new Date();

  return formatDistance(dateObj, now, { addSuffix: true });
}
